import { EFolderType } from '@modules/items/types/folders.types';
import { TERMINOLOGY } from '@shared/i18n';

import type { TDocument } from '../types';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/ai/common/src/checkAiTargetIsIndexed.ts
export enum EAiDisabledReason {
  BLOCK = 'BLOCK',
  COUNTRY = 'COUNTRY',
  SNAPSHOT = 'SNAPSHOT',
}

const AI_DISABLED_ANCESTOR_REASONS: ReadonlyMap<EFolderType, EAiDisabledReason> = new Map([
  [EFolderType.COUNTRY, EAiDisabledReason.COUNTRY],
  [EFolderType.SNAPSHOT, EAiDisabledReason.SNAPSHOT],
]);

export const AI_DISABLED_MESSAGE: Readonly<Record<EAiDisabledReason, string>> = Object.freeze({
  [EAiDisabledReason.BLOCK]: `AI is not available for ${TERMINOLOGY.block.lower}.`,
  [EAiDisabledReason.COUNTRY]: `AI is not available for ${TERMINOLOGY.registrationFull.lower}.`,
  [EAiDisabledReason.SNAPSHOT]: `AI is not available for ${TERMINOLOGY.snapshots.lower}.`,
});

// Shared by AI edit and Q&A: neither runs where nothing is indexed - a block document, or a
// document under a country-registration or snapshot ancestor. The reason picks the message.
const getAiDisabledDocumentReason = (doc: TDocument): EAiDisabledReason | undefined => {
  if (doc.isBlock) return EAiDisabledReason.BLOCK;

  for (const pathItem of doc.resolvedPath) {
    const reason = pathItem.folderType && AI_DISABLED_ANCESTOR_REASONS.get(pathItem.folderType);
    if (reason) return reason;
  }

  return undefined;
};

export default getAiDisabledDocumentReason;
